import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { ContentCardProps, UI_ContentCard } from 'ui/components/2-molecules/Card/ContentCard/ContentCard';
import styles from './ContentCardList.module.scss';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import IconArrow from 'ui/icons/icon_right_arrow.svg';
import classNames from 'classnames';

export interface ContentCardListProps {
	className?: string;
	heading?: string;
	link?: { url: string; target: string; name: string };
	contentCardItems: ContentCardProps[];
	maxNumberOfColumns?: 3 | 4;
}

export const UI_ContentCardList = ({ heading, link, contentCardItems, maxNumberOfColumns = 3 }: ContentCardListProps) => {
	return (
		<div className={classNames(styles.ContentCardList, styles[`ContentCardList___items${maxNumberOfColumns}`])}>
			{heading && (
				<UI_Heading headingLevel="h2" style="lg50" className={styles.ContentCardList_heading}>
					{heading}
				</UI_Heading>
			)}
			{link?.url && (
				<UI_LinkWithIcon
					className={styles.ContentCardList_link}
					url={link.url}
					target={link.target}
					icon={
						<span className={styles.ContentCardList_linkIcon}>
							<IconArrow />
						</span>
					}
					text={link.name}
				/>
			)}
			<div className={styles.ContentCardList_items}>
				{contentCardItems?.map((item, index) => <UI_ContentCard key={index} className={styles.ContentCardList_item} {...item} />)}
			</div>
		</div>
	);
};
